import moment from 'moment';
import datePicker from "vue-bootstrap-datetimepicker";

Vue.component('live-stats', {
    components: {
        datePicker
    },

    data () {
        return {
            dates: {
                from: moment().startOf('today').format("DD-MM-YYYY"),
                to: moment().endOf('today').format("DD-MM-YYYY")
            },

            audio: null,

            newSale: false,

            loading: false,

            dashboardData: null,

            timeout: null,

            tpOptions: {
                format: 'DD-MM-YYYY',
            },

            leaderboard: 'kpi'
        };
    },

    mounted () {
        $('body').removeClass('sidebar-lg-show');

        localStorage.removeItem('lastDateCheck');
    },

    methods: {
        handleDateSelected (field, value) {
            this.dates[field] = value;

            clearTimeout(this.timeout);

            this.pollData();
        },

        showNewSale (name) {
            this.newSale = name;

            var audio = new Audio('/sounds/success.mp3');
            audio.play();

            audio.addEventListener('ended', () => {
                setTimeout(() => {
                    this.newSale = false;
                }, 5000);
            });
        },

        pollData () {
            this.loading = true;

            // Check the time and date
            let today = moment().format("DD-MM-YYYY");
            const lastDateCheck = localStorage.getItem('lastDateCheck');

            if (lastDateCheck == null) {
                localStorage.setItem('lastDateCheck', today);
            } else if (lastDateCheck != today) {
                // Increment the date parameters by 2 days
                this.dates.from = moment(this.dates.from, "DD-MM-YYYY").add(1, 'day').format("DD-MM-YYYY");
                this.dates.to = moment(this.dates.to, "DD-MM-YYYY").add(1, 'day').format("DD-MM-YYYY");

                localStorage.setItem('lastDateCheck', today);
            }

            const { from, to } = this.dates;

            axios.get('/api/dashboard/live', {
                params: {
                    from,
                    to
                }
            }).then((response) => {
                this.dashboardData = response.data;

                if (response.data.new_sale) {
                    this.showNewSale(response.data.new_sale);
                }

                this.loading = false;

                this.recheckScroll();
            });

            this.timeout = setTimeout(this.pollData, 20000);
        },

        recheckScroll () {
            setTimeout(() => {
                let innerHeight = document.querySelector('.scrollable-pipeline .inner').clientHeight;
                let parentHeight = document.querySelector('.scrollable-pipeline').clientHeight;

                if (innerHeight > parentHeight) {
                    clearInterval(this.pipelineScroll);

                    this.pipelineScroll = setInterval(() => {
                        document.querySelector('.scrollable-pipeline').scrollBy(0, 1);

                        const maxScrollHeight = document.querySelector('.scrollable-pipeline').scrollHeight - document.querySelector('.scrollable-pipeline').offsetHeight;
                        const scrollPosition = document.querySelector('.scrollable-pipeline').scrollTop;

                        if (scrollPosition >= maxScrollHeight) {
                            document.querySelector('.scrollable-pipeline').scrollTop = 0;
                        }
                    }, 50);
                } else {
                    clearInterval(this.pipelineScroll);
                }

                let innerWidth = document.querySelector('.scrollable-admin .inner').clientWidth - 30;
                let parentWidth = document.querySelector('.scrollable-admin').clientWidth;

                if (innerWidth > parentWidth) {
                    clearInterval(this.adminScroll);

                    this.adminScroll = setInterval(() => {
                        document.querySelector('.scrollable-admin').scrollBy(1, 0);

                        const maxScrollWidth = document.querySelector('.scrollable-admin').scrollWidth - document.querySelector('.scrollable-admin').offsetWidth;
                        const scrollPosition = document.querySelector('.scrollable-admin').scrollLeft;

                        if (scrollPosition >= maxScrollWidth) {
                            document.querySelector('.scrollable-admin').scrollLeft = 0;
                        }
                    }, 50);
                } else {
                    clearInterval(this.adminScroll);
                }
            });
        }
    },

    computed: {
        sortedAdmins () {
            let admins = this.dashboardData.admins.sort((b, a) => {
                if (this.leaderboard === 'kpi') {
                    return a.month_progress - b.month_progress;
                } else if (this.leaderboard === 'sales') {
                    return a.sales - b.sales;
                }
                
                // if (hasSales.length > 0) {
                //     return a.sales - b.sales;
                // } else {
                //     return a.prospects - b.prospects;
                // }
            });

            let position = 1;
            for (let admin in admins) {
                admins[admin].position = position++;
            }

            return admins;
        }
    }
});

